import { useTranslation } from 'react-i18next'
import { WizardState } from '../types/index'

interface Props {
  state: WizardState
  updateState: (updates: Partial<WizardState>) => void
}

export function Step3({ state, updateState }: Props) {
  const { t } = useTranslation()
  return (
    <div style={{ width: '100%', maxWidth: 480, textAlign: 'center' }}>
      <h1 style={{ fontSize: 28, fontWeight: 'bold', color: '#111827', marginBottom: 40 }}>{t('step3.title')}</h1>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        {(['mixed', 'separate'] as const).map(mode => (
          <button
            key={mode}
            onClick={() => updateState({ studyMode: mode })}
            style={{
              padding: 24, borderRadius: 20, textAlign: 'left', cursor: 'pointer',
              border: state.studyMode === mode ? 'none' : '2px solid #E5E7EB',
              backgroundColor: state.studyMode === mode ? '#1c3fff' : 'white',
              color: state.studyMode === mode ? 'white' : '#374151',
              transition: 'all 0.2s'
            }}
          >
            <div style={{ fontSize: 28, marginBottom: 12 }}>{mode === 'mixed' ? '⊞' : '📅'}</div>
            <div style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 4 }}>{t('step3.' + mode)}</div>
            <div style={{ fontSize: 13, opacity: 0.8 }}>{t('step3.' + mode + 'Desc')}</div>
          </button>
        ))}
      </div>
    </div>
  )
}
